"use strict";

var $ = require("jquery");

$(document).ready(function () {

    $('.woocommerce-form__label-for-checkbox').addClass('custom-control').addClass('custom-checkbox');
    $('.woocommerce input[type="checkbox"]').addClass('custom-control-input');
    $('.woocommerce-form__label-for-checkbox span').addClass('custom-control-label');
});